import { ReactComponent as ChevronRight } from '@assets/images/app/chevron-right-nutral70.svg';
import { ReactComponent as DefaultAvatar } from '@assets/images/app/default-avatar-gray.svg';
import { ProductModel } from '@models/product';
import { cdnImageUrl } from '@utils/image';
import React from 'react';

export const ProductPartnerSummary: React.FC<{ data: ProductModel }> = (props) => {
  const { data } = props;

  return (
    <div
      style={{
        padding: '20px',
        marginBottom: 0,
        backgroundColor: '#ffffff',
      }}>
      <div>
        <button className="link-button" style={{ height: '32px', display: 'flex', alignItems: 'center' }}>
          {data.sellerProfileImage ? (
            <img
              src={cdnImageUrl(data.sellerProfileImage)}
              alt="partner"
              style={{ width: '32px', height: '32px', display: 'block', objectFit: 'cover', borderRadius: '16px' }}
            />
          ) : (
            <DefaultAvatar
              style={{ width: '32px', height: '32px', display: 'block', objectFit: 'cover', borderRadius: '16px' }}
            />
          )}
          <div
            style={{
              color: 'var(--Neutral-100, #242424)',
              fontFamily: 'Pretendard',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 700,
              marginLeft: '12px',
            }}>
            {data.sellerName}
          </div>
          <ChevronRight />
        </button>
        {data.sellerIntroduction && (
          <div
            style={{
              marginTop: '12px',
              color: 'var(--Neutral-90, #424242)',
              fontFamily: 'Pretendard',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '24px',
              display: '-webkit-box',
              maxWidth: '100%',
              maxHeight: '72px',
              WebkitLineClamp: '3',
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              wordBreak: 'break-all',
              whiteSpace: 'pre-wrap',
            }}>
            {data.sellerIntroduction}
          </div>
        )}
      </div>
    </div>
  );
};
